import { RoleUI } from '../../types/interfaces';
import IApiCalls from '../api/interfaces/apiCalls';

import BaseService from './BaseService';
import IRoleUIsService from './interfaces/RoleUIsService';

class RoleUIsService extends BaseService<RoleUI> implements IRoleUIsService {
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'RoleUIs');
  }
}

export default RoleUIsService;
